export const colNotAvailableTip = function () {
  return function(string) {
    if (!string) return null;
    return "Google only";
  };
};

// colNotAvailableTip.$inject = [''];